import { Injector, ChangeDetectorRef } from '@angular/core';
import { TitleCasePipe } from '@angular/common';
import { FormGroup } from '@angular/forms';
import {
  DisplayCardsComponent,
  DisplayFormComponent,
  DisplayFormProcessResponse,
  DisplayCardsProcessResponse,
  CONTROL_FNAME,
  CONTROL_LNAME,
  CONTROL_DOB,
  CONTROL_ZIP,
  PhonePipe,
} from '@brightside-web/shared/desktop';
import { TranslatePipe } from "@ngx-translate/core";
import { InviteService, CompanyService } from '@brightside-web/desktop/data-access/shared';
import { RegistrationService, PrecheckResponse } from '@brightside-web/desktop/data-access/onboarding';


import {
  BsCacheService
} from '@brightside-web/desktop/data-access/core-services';
import { Observable } from 'rxjs';

import * as moment from 'moment';

const ROUTES_PATH = 'discover';
const ROUTES = [

  {
    path: 'birthday',
    component: DisplayFormComponent,
    data: {
      breadcrumb: { skip: true },
      pageConfig: {
        fbEventName: 'verify_dob',
        pageTitleKey: 'VERIFY_BIRTHDAY',
        pageCtaLabelKey: 'BUTTON_CONTINUE',
        pageFormControls: [CONTROL_DOB],

        pageOnForwardCtaPath: ['registration', ROUTES_PATH, 'employer'],
        pageOnBackCtaPath: ['registration', 'sign_up'],
        processUpdater: (injector: Injector, form: FormGroup, translatePipe: TranslatePipe) => {
          const observable = new Observable<DisplayFormProcessResponse>((subscriber) => {
            const birthday = form.get(CONTROL_DOB.key)?.value;
            InviteService.getPreCacheHousehold().then(
              cachedDetails => {
                if (birthday) {
                  InviteService.preCacheHousehold({
                    fName: cachedDetails.fName,
                    lName: cachedDetails.lName,
                    dateOfBirth: moment(birthday).format('YYYY-MM-DD'),
                    lastFourSSN: cachedDetails.lastFourSSN,
                    email: cachedDetails.email || '',
                  });
                }

                subscriber.next({ status: 'success' });
                subscriber.complete();
              }
            )
          });

          return observable;
        },
      },
    },
  },
  {
    path: 'verify-household',
    component: DisplayFormComponent,
    data: {
      breadcrumb: { skip: true },
      pageConfig: {
        fbEventName: 'verify_employee_information',
        pageTitleKey: 'PRIMARY_VERIFICATION_TITLE_WEB',
        pageSubTitleKey: 'PRIMARY_VERIFICATION_DESC_WEB',
        pageCtaLabelKey: 'BUTTON_CONTINUE',

        pageFormControls: [CONTROL_FNAME, CONTROL_LNAME, CONTROL_DOB, CONTROL_ZIP],
        pageFormControlFullWidth: true,

        pageOnForwardCtaPath: ['registration', 'create-account'],

        processUpdater: (injector: Injector, form: FormGroup, translatePipe: TranslatePipe) => {
          const observable = new Observable<DisplayFormProcessResponse>((subscriber) => {
            const inviteService: InviteService = injector.get(InviteService);
            const registrationService: RegistrationService = injector.get(RegistrationService);
            const companyService: CompanyService = injector.get(CompanyService);

            const employeeInfo = {
              fName: form.get(CONTROL_FNAME.key)?.value || '',
              lName: form.get(CONTROL_LNAME.key)?.value || '',
              dateOfBirth: moment(form.get(CONTROL_DOB.key)?.value || '').format('YYYY-MM-DD'),
              zipCode: form.get(CONTROL_ZIP.key)?.value || '',
            };

            inviteService.verifyDependentEmployee(employeeInfo).subscribe(
              () => {
                InviteService.getPreCacheHousehold().then(
                  dependent => {
                    registrationService
                      .newRegistrationPrecheck({
                        first_name: dependent.fName,
                        last_name: dependent.lName,
                        last_four_ssn: dependent.lastFourSSN,
                        date_of_birth: dependent.dateOfBirth,
                      })
                      .subscribe(
                        (resp: PrecheckResponse) => {
                          BsCacheService.setItemStatic('firstName', dependent.fName);
                          BsCacheService.setItemStatic('lastName', dependent.lName);
                          BsCacheService.setItemStatic('last4ssn', dependent.lastFourSSN);
                          BsCacheService.setItemStatic('email', dependent.email);

                          BsCacheService.setItemStatic('create-account', 'allowed');
                          BsCacheService.setItemStatic('dob', dependent.dateOfBirth);
                          BsCacheService.setItemStatic('clientType', resp.clientType);
                          if (resp.company) {
                            companyService.setCompany(resp.company);
                          }

                          subscriber.next({ status: 'success' });
                          subscriber.complete();
                        },
                        () => {
                          subscriber.next({ status: 'failed' });
                          subscriber.complete();
                        }
                      );
                  }
                )

              },
              (error) => {
                let errorMessage = '';
                let errorMessageTitle = '';

                if (error.response.data.statusCode === 409) {
                  errorMessage = error.response.data.errorMessage || '';
                  errorMessageTitle = '';
                }

                subscriber.next({ status: 'failed', errorMessage, errorMessageTitle });
                subscriber.complete();
              }
            );
          });

          return observable;
        },
      },
    },
  }
];

export { ROUTES, ROUTES_PATH };
